import React, { useState } from 'react';
import Piechartitems from "../hqReport/Piechartitems";
import Piechartitems2 from "../hqReport/Piechartitems2";
import Piechartitems3 from "../hqReport/Piechartitems3";
import Billinvoice from "../hqReport/Billinvoice";
import Chart from './Chart';

function Piechart({ invoicesByMonth, monthlyPaidStatusCounts, monthlyPaidStatusAmounts }) {
  const { thisMonth, lastMonth, twoMonthsAgo } = invoicesByMonth || {};
  const paidAmounts = monthlyPaidStatusAmounts || {};
  const hasThisMonth =
    thisMonth > 0 &&
    (paidAmounts?.thisMonth?.paid > 0 ||
      paidAmounts?.thisMonth?.outstanding > 0);

  const hasLastMonth =
    lastMonth > 0 &&
    (paidAmounts?.lastMonth?.paid > 0 ||
      paidAmounts?.lastMonth?.outstanding > 0);

  const hasTwoMonthsAgo =
    twoMonthsAgo > 0 &&
    (paidAmounts?.twoMonthsAgo?.paid > 0 ||
      paidAmounts?.twoMonthsAgo?.outstanding > 0);

  return (
    <div className="reportmap">
      <div className="reportmap_1">
        {hasThisMonth && (
          <Chart
            label="This Month"
            amount={thisMonth}
            statusCounts={monthlyPaidStatusCounts.thisMonth}
            statusAmounts={paidAmounts.thisMonth}
          />
        )}

        {hasLastMonth && (
          <Chart
            label="Last Month"
            amount={lastMonth}
            statusCounts={monthlyPaidStatusCounts.lastMonth}
            statusAmounts={paidAmounts.lastMonth}
          />
        )}

        {hasTwoMonthsAgo && (
          <Chart
            label="2 Months Ago"
            amount={twoMonthsAgo}
            statusCounts={monthlyPaidStatusCounts.twoMonthsAgo}
            statusAmounts={paidAmounts.twoMonthsAgo}
          />
        )}

        {(hasThisMonth || hasLastMonth || hasTwoMonthsAgo) && (
          <Billinvoice />
        )}
      </div>
    </div>
  );
}

export default Piechart;
